import React from 'react'
import { TyresWear, TYRE_SIDE } from '../components'
import FORM_FIELDS_TYPE from '../constants'

const formFields = {
  [FORM_FIELDS_TYPE.WEAR]: [
    {
      nodes: [
        props => <TyresWear.FormItem side={TYRE_SIDE.FRONT} {...props} />,
        props => <TyresWear.FormItem side={TYRE_SIDE.BACK} {...props} />
      ]
    }
  ]
}

export default { formFields }
